import { z } from "zod/v4"
import type { EventType } from "@common_lib/base/constants/eventTypeConst"

// EventType is a const enum, so there is no runtime object for z.enum() to read;
// validate the number and keep the enum type for callers.
export const eventTypeSchema = z.custom<EventType>(value => typeof value === "number")

// For endpoints whose response body nobody reads. Reading it later needs a real schema.
export const unreadResponseSchema = z.unknown()

// The empty body ("") a handler answers when it bails out early is not part of any schema:
// those early returns are guards the backend should answer with an error code.
// See the empty-body section of docs/api-contract-audit.md.

export const emptyArraySchema = z.tuple([])

// Some handlers answer "{}" when there is nothing to report.
export const emptyObjectSchema = z.record(z.string(), z.never())

export const isEmptyObject = <T extends object>(
  response: T | z.infer<typeof emptyObjectSchema>
): response is z.infer<typeof emptyObjectSchema> => Object.keys(response).length === 0
